import {FirebaseOptions} from "@firebase/app";


export const firebase: FirebaseOptions = {
  apiKey: "AIzaSyBW8Zx0BqELF195TEdq0zEyJyvTtKKp2jM",
  authDomain: "mer-connect-dev-qa.firebaseapp.com",
  projectId: "mer-connect-dev-qa",
  storageBucket: "mer-connect-dev-qa.appspot.com",
  messagingSenderId: "181468596384",
  appId: "1:181468596384:web:5e018747c6a68b1bc9a1c5",
  measurementId: "G-ME75TYRST0"
};

console.log('dev env');
console.log('dev env sdfgsdfsdf' );


export const firebaseHub = {
  apiKey: "AIzaSyAUMlp99vgZv4DR64enoCYB7WiWdUAWuGs",
  authDomain: "merhub-test-999e1.firebaseapp.com",
  projectId: "merhub-test-999e1",
  storageBucket: "merhub-test-999e1.firebasestorage.app",
  messagingSenderId: "915602409554",
  appId: "1:915602409554:web:ea95c949c9e27963c1b78b",
  measurementId: "G-K61SJZC91T"
};


export const environment = {
  production: false,
  bffBaseUrl: "https://dev.api.cor.mer.eco/cor-mer-connect-bff/v1/",
  merBaseUrl: "https://dev.api.cor.mer.eco/",
  msal: {
    AUTHORITY: "https://login.microsoftonline.com/5a6741a5-c5f9-4f82-90ed-c23747406f0a/v2.0",
    CLIENT_ID: "MER_CONNECT_ADMIN_PORTAL_CLIENT_ID",
    KNOWN_AUTHORITIES: ["dev.identity.mer.eco"],
    REDIRECT_URL: "https://dev.admin.connect.mer.eco/",
    SCOPES: ["MER_CONNECT_ADMIN_PORTAL_SCOPE"],
  }
};
